import { render, staticRenderFns } from "./fleetStatus.vue?vue&type=template&id=601c5f69&"
import script from "./fleetStatus.vue.js?vue&type=script&lang=js&"
export * from "./fleetStatus.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports